<template>
    <!--确认订单页面-->
    <div class="container">
        <remote-script src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-script>
        <!--有地址列表时显示第一个默认地址-->
        <div class="chooseAdr clearfix" v-if="noAdr">
            <div class="adrbtn fl">
                <em class="iconfont icon-weizhi1"></em>
            </div>
            <div class="adrMidd fl">
                <div class="clearfix">
                    <p class="fl">收件人:<span v-text="addressee"></span></p>
                    <p class="fr" v-text="phone"></p>
                </div>
                <p class="adrdel twoEllipsis" v-text="address"></p>
            </div>
            <!--<router-link class="fr adrRight" :to="{path:'myAddr',query:{id:this.$route.query.id}}">-->
            <router-link class="fr adrRight" :to="{path:'/myAddr',query:{id:this.$route.query.id}}">
                <em class="iconfont icon-youjiantou"></em>
            </router-link>
        </div>
        <!--没有任何地址信息时显示-->
        <router-link class="noAddr" v-else to="addr">暂无收获地址，立即添加</router-link>
        <div class="lineBg"><img src="../assets/line.png"/></div>
        <!--商品信息-->
        <div class="shopdelBox clearfix boxSizing">
            <div class="shopimg fl"><img :src="bookCover"/></div>
            <div class="shopMsg">
                <p class="shopName twoEllipsis" v-text="booktit"></p>
                <div class="clearfix shopNP">
                    <p class="shopPrice fl">￥<span v-text="bookPrice"></span></p>
                    <p class="shopNum fr">数量：x<span v-text="currNum"></span></p>
                </div>
            </div>
        </div>
        <!--编辑数量-->
        <div class="editNum clearfix">
            <span class="fl">购买数量</span>
            <p class="editBtn fr">
                <span class="reduce iconfont icon-jian" @click="reduce"></span>
                <input type="text" class="currNum" value="10000" maxlength="5" v-model="currNum" @input="handleInput($event)">
                <span class="increase iconfont icon-jia" @click="increase"></span>
            </p>
        </div>
        <!--运费-->
        <div class="freight clearfix">
            <span class="fl">运费</span>
            <span class="fr">包邮</span>
        </div>
        <!--选择红包-->
        <div class="packet clearfix">
            <span class="fl">红包</span>
            <span class="choPacket fr" @click="showPack" v-text="packState"></span>
        </div>
        <!--选择红包组件-->
        <choosePacket v-if="packShow" @childoff="offPack" :book-num="currNum" @choosed="packChoosed"></choosePacket>
        <!--留言-->
        <div class="userMsg clearfix">
            <span>留言</span>
            <textarea class="fr remark" placeholder="建议留言前先与商家沟通企确认" maxlength="100" v-model="user_remark" ></textarea>
        </div>
        <!--提交订单-->
        <div class="orderSubmit clearfix" v-show="isShow">
            <p class="totPrice fl">金额合计：<span v-text="totPrice"></span></p>
            <button class="submitBtn fr" @click="payshop" :disabled="stopSubmit">提交订单</button>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import qs from "qs";
    import choosePacket from "../components/redpacket/choosePacket";
    import { MessageBox } from "mint-ui";
    import common from "../common";

    //从地址列表获取第一个默认地址
    function getAddr(vue) {
        var _this = vue;
        var wxindex = common.getUrlKey('index');//微信支付刷新本页面后，无query参数，可从url获取
        //alert(_this.$route.query.index);
        //alert(common.getUrlKey('index'));
        // var adrIndex = _this.$route.query.index||wxindex;
        var quIndex = _this.$route.query.index;
        var adrIndex = quIndex ? quIndex : wxindex;
        axios
            .post(
                "/wap/AddrHandle/addrList",
                qs.stringify({
                    page: 1
                })
            )
         .then(data => {
             var data = data.data.data;
             if(data.length === 0) {
                 _this.noAdr = false;
             }else{
                 _this.noAdr = true;
             }
             var data1 = data[0];//默认地址列表
             var data2 = data[adrIndex];//选择后的地址
             _this.addr_id = adrIndex ? data2.id : data1.id;
             _this.addressee = adrIndex ? data2.addressee : data1.addressee;
             _this.phone = adrIndex ? data2.phone : data1.phone;
             _this.address = adrIndex ? data2.address : data1.address;

        })
        ["catch"](error => {
            console.log(error);
        });
    };
    export default {
        name: "editOrder",
        mounted() {
            window.onresize = () =>{
                this.showHeight = document.documentElement.clientHeight;
            };
            var _this = this;
            //修改支付弹框
            this.payMsgBox();
            //结束
            // //支付弹框
            // if(localStorage.getItem('ifwxpay')){
            //     setTimeout(function () {
            //         MessageBox.confirm('是否已支付完成？',{
            //             title:"提示",
            //             // cancelButtonText:'未支付',
            //             confirmButtonClass:'confirmButton',
            //             cancelButtonClass:'cancelButton',
            //         })
            //         .then((action) => {
            //             localStorage.removeItem('ifwxpay');
            //             if (action == 'confirm') {
            //                 _this.$router.push({path:'/orderDel',query:{id:localStorage.getItem('orderId')}});
            //                 // this.$router.push({path:'/orderDel',query:{id:localStorage.getItem('orderId'),packetMony:_this.decPrice}});
            //             }
            //         })
            //         ["catch"]((err) => {
            //             if(err == 'cancel'){
            //                 localStorage.removeItem('ifwxpay');
            //                 //取消支付刷新当前页面
            //                 _this.$router.go(0);
            //             }
            //             return false;
            //         });
            //     },2000);
            // }

            this.wxPayapi();
            //微信内支付-->支付刷新页面，获取code,state
            // var state = common.getUrlKey('state');
            // var code = common.getUrlKey('code');
            // if (state && code) {
            //     //调用支付接口
            //     this.$WxJsapiPay("/wap/WxpayFor/sendCode", {state: state,code: code}, (res)=>{
            //         return true;
            //     },(err)=>{
            //         this.Toast({ message: err.msg, position: "center", duration: 2000 });
            //     });
            // }
        },
        components: {
            choosePacket
        },
        data() {
            return{
                bookCover: localStorage.getItem('bookCover') ,//图书封面
                booktit: localStorage.getItem('booktit') ,//图书名称
                bookPrice: localStorage.getItem('bookPrice'),//图书价格
                currNum: '1',//当前购买数量
                decPrice: '0',//使用红包抵扣的金额
                packId : '',//红包ID
                packState: '选择红包',
                // packState: {
                //     0 : '',
                //     1 : '红包已抵扣'+ this.decPrice +'元'
                // },//是否使用了红包
                addr_id: '',
                goods_id: '',
                user_remark: '',
                addressee: '',
                phone: '',
                address: '',
                noAdr: false,
                packShow: false,
                documentHeight:document.documentElement.clientHeight ,
                showHeight: document.documentElement.clientHeight,
                isShow: true,
                stopSubmit: false,
                orderId: '',
                iswx: false,
                iswxpc: false
                // totPrice: ''
            }
        },
        computed: {
            //计算合计金额
            totPrice: function () {
                //单价 * 数量
                var price = common.floatObj().multiply(localStorage.getItem('bookPrice'),this.currNum);
                //减去红包的价格
                var finPrice = common.floatObj().subtract(price,this.decPrice);
                return finPrice;
            }
        },
        watch: {
            // showHeight() {
            //     if (this.documentHeight > this.showHeight) {
            //        this.isShow = false;
            //     } else if (this.documentHeight = this.showHeight) {
            //         this.isShow = true;
            //     }
            // }
        },
        created() {
            getAddr(this);
            let IsOS = navigator.userAgent.toLowerCase();
            this.iswx = IsOS.indexOf("micromessenger") > -1;
            this.iswxpc = IsOS.indexOf("windowswechat") > -1;
        },
        methods: {
            //提交订单
            payshop: function () {
                //提交按钮不可点击
                this.stopSubmit = true;
                //存储ifwxpay,解决谷歌不跳转直接刷新
                localStorage.setItem('ifwxpay',true);
                var myIP = returnCitySN.cip;
                axios
                    .post(
                        "wap/WxPayFor/pay4send",
                        qs.stringify({
                            addr_id: this.addr_id,
                            goods_id: this.$route.query.id ? this.$route.query.id : common.getUrlKey('id'),
                            goods_num: this.currNum,//localStorage.getItem("currNum")
                            user_remark: this.user_remark,
                            urb_id: this.packId,
                            ip: myIP,
                            index: this.$route.query.index || ''
                        })
                    )
                    .then(data => {
                        //提交按钮恢复可点击
                        this.stopSubmit = false;
                        if (data.data.code == 200) {
                            console.log(data);
                            //修改开始
                            //没有state,走浏览器端微信支付，弹框解决支付后页面不刷新问题
                            if(!this.iswx){
                                //解决ios浏览器跳到首页重定向
                                localStorage.setItem("IsPayStatuCodeByH5", "1");
                                var path = window.location.href;
                                localStorage.setItem("RedirectPath",path);
                                //调起支付后弹框
                                this.payMsgBox();
                            };
                            //调起支付 跳转
                            location.href = data.data.data.url;
                            this.orderId = data.data.data.orderId;
                            localStorage.setItem('orderId', data.data.data.orderId);
                            //var _this = this;
                            // MessageBox.confirm('是否已支付完成？', {
                            //     title: "提示",
                            //     // cancelButtonText:'未支付',
                            //     confirmButtonClass: 'confirmButton',
                            //     cancelButtonClass: 'cancelButton',
                            //
                            // })
                            //     .then((action) => {
                            //         if (action == 'confirm') {
                            //             localStorage.removeItem('ifwxpay');
                            //             _this.$router.push({
                            //                 path: '/orderDel',
                            //                 query: {id: _this.orderId, packetMony: _this.decPrice}
                            //             });
                            //             console.log(_this);
                            //         }
                            //
                            //     })
                            //     ["catch"]((err) => {
                            //         if (err == 'cancel') {
                            //             localStorage.removeItem('ifwxpay');
                            //         }
                            //         return false;
                            //     });
                            //修改结束
                        } else {
                            //console.log(JSON.stringify(data));
                            this.Toast({
                                message: data.data.msg,
                                position: "center",
                                duration: 2000
                            });
                        }
                    })
                    ["catch"](error => {
                        console.log(error);
                    });
            },
            //用户留言
            handleInput: function (e) {
                this.currNum = e.target.value.replace(/[^\d]/g,'');
            },
           //编辑数量
            reduce: function () {
                if (this.currNum > 1) {
                    this.currNum--;
                    //localStorage.setItem('currNum',this.currNum);
                }
            },
            increase: function () {
                if (this.currNum < 99999) {
                    this.currNum++;
                    //localStorage.setItem('currNum',this.currNum);
                }
            },
            //去选择红包
            showPack: function () {
                this.packShow = true;
                //common.stop();
            },
            offPack: function (data) {
                this.packShow = false;
                //common.move();
            },
            //选中红包 进行减价
            packChoosed: function (price,id) {
               this.decPrice = price;
               this.packState = '红包已抵扣'+ price +'元';
               this.packId = id;
            },
            //为支付回调所作的弹框
            payMsgBox:function () {
                var _this = this;
                if(localStorage.getItem('ifwxpay')){
                    setTimeout(function () {
                        MessageBox.confirm('是否已支付完成？',{
                            title:"提示",
                            confirmButtonClass:'confirmButton',
                            cancelButtonClass:'cancelButton',
                        })
                            .then((action) => {
                                localStorage.removeItem('ifwxpay');
                                if (action == 'confirm') {
                                    localStorage.removeItem('IsPayStatuCodeByH5');
                                    _this.$router.push({path:'/orderDel',query:{id:localStorage.getItem('orderId')}});
                                }
                            })
                            ["catch"]((err) => {
                                if(err == 'cancel'){
                                    localStorage.removeItem('IsPayStatuCodeByH5');
                                    localStorage.removeItem('ifwxpay');
                                    //取消支付刷新当前页面
                                    _this.$router.go(0);
                                }
                                return false;
                            });
                    },2000);
                };
            },
            wxPayapi:function () {
                //微信内支付-->支付刷新页面，获取code,state
                var state = common.getUrlKey('state');
                var code = common.getUrlKey('code');
                if (state && code) {
                    //调用支付接口
                    this.$WxJsapiPay("/wap/WxpayFor/sendCode", {state: state,code: code}, (res)=>{
                        return true;
                    },(err)=>{
                        this.Toast({ message: err.msg, position: "center", duration: 2000 });
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .container{
        font-size: 26px;
    }
    .chooseAdr,.noAddr{
        height: 180px;
    }
    .noAddr{
        display: block;
        line-height: 180px;
        text-align: center;
        color: #666;
    }
    .adrbtn{
        width: 10%;
        font-size: 40px;
        text-align: center;
        height: 180px;
        line-height: 180px;
        em{
            font-size: 40px;
        }
    }
    .adrMidd{
        width: 80%;
        div{
            margin: 34px 0 16px;
        }
        .adrdel{color: #666}
    }
    .adrRight{
        width: 10%;
        text-align: center;
        height: 180px;
        line-height: 180px;
    }
    .icon-youjiantou{
        font-size: 40px;
        color: #333;
    }
    .icon-jian,.icon-jia{
        color: #333;
    }
    .lineBg{
        border-bottom: 20px solid #F6F7F8;
    }
    /*商品信息*/
    .shopdelBox{
        padding: 30px;
        border-bottom: 20px solid #F6F7F8;
        .shopimg{
            img{
                width: 200px;
                height: 200px;
                margin-right: 20px;
            }
        }
        .shopName{
            font-size: 28px;
            margin: 30px 0;
        }
        .shopNP{
            line-height: 30px;
        }
        .shopPrice{
            font-size: 32px;
            color: #D63C32;
            font-weight: bold;
        }
        .shopNum{
            color: #999;
            font-size: 24px;
        }
    }
    /*编辑数量*/
    .editNum{
        padding: 0 30px;
        line-height: 86px;
        border-bottom: 1PX solid #E1E1E1;
        .currNum{
            display: inline-block;
            width: 100px;
            height: 54px;
            line-height: 54px;
            margin: 0 20px;
            font-size: 28px;
            text-align: center;
            background: #e5e5e5;
        }
    }
    .freight,.packet{
        padding: 0 30px;
        line-height: 86px;
        border-bottom: 1PX solid #E1E1E1;
    }
    .choPacket{
        color: #D63C32;
    }
    /*用户留言*/
    .userMsg{
        padding: 0 30px 140px;
        margin-top: 30px;
        span{
            width: 10%;
        }
        textarea{
            width: 90%;
            height: 200px;
            font-size: 22px;
        }
    }
    /*提交*/
    .orderSubmit{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 98px;
        line-height: 98px;
        background: #fff;
        border-top: 1PX solid #e1e1e1;
        .submitBtn{
            width: 30%;
            height: 100%;
            border: none;
            text-align: center;
            background: #FF8B11;
            color: #fff;
            font-size: 30px;
        }
        .totPrice{
            padding-left: 30px;
            span{
                color: #D2423D;
            }
        }
    }
</style>
